import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Breadcrumbs, Typography } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { light_theme_solid_blue, light_theme_black } from '../../../constants/constants'
import { use } from 'i18next';
import HomeIcon from '@mui/icons-material/Home';

import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { t } from "i18next";

// const TitleContainer = styled.div`
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;
//     margin-bottom: 2rem;
//     @media(max-width: 768px) {
//         flex-direction: column;
//         padding-left: 0.6rem;
//     }
// `

// const Title = styled.div`
//     color: ${light_theme_black};
//     font-family: Inter;
//     font-size: 20px;
//     font-weight: 600;
//     line-height: 24px;
//     letter-spacing: 0em;
//     text-align: left;

// `
// const BreadCrumbContainer = styled.div`
//     font-size: 14px;
//     color: #000000;
//     @media(max-width: 768px) {
//         margin-top: 1rem;
//     }
// `
import {useDispatch} from 'react-redux';
import {setConsentId} from '../../system/redux/reducers/consentId';
import { setReloadFeedbackDetails } from '../../system/redux/reducers/reloadFeedbackDetails';
function PageHeadContainer({ pageTitle, pathArray, Dashboardtoggle }) {
    const dispatch = useDispatch();


    const handleBreadcrumbClick = () => {
        if (Dashboardtoggle) {
            Dashboardtoggle();
            dispatch(setReloadFeedbackDetails({switchToDashboardView:true}));
            dispatch(setConsentId(0));
            console.log('pageheader');
        }
    }
    useEffect(() => {
        // console.log("Path Array ", pathArray);
    });
    return (
        <div className='d-md-flex align-items-center justify-content-between'>
            <h5 className='h5 fw-bold'>
                {pageTitle}
            </h5>


            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                {
                pathArray.slice(1).map((path, index) => {
                    console.log("Path ", path);
                    return (
                        <Typography key={index} color={index !== pathArray.length - 2 ? light_theme_solid_blue : light_theme_black}>
                            {index === 0 ? (
                                <Breadcrumb.Item active onClick={handleBreadcrumbClick}>
                                    <i className="ti ti-home"></i> {t("label.general.navigation.home")}
                                </Breadcrumb.Item>
                            ) : path}
                        </Typography>
                    )
                })}


            </Breadcrumbs>

        </div>
    )
}
PageHeadContainer.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    path: PropTypes.arrayOf(PropTypes.string).isRequired,
};
export default PageHeadContainer